import styled from 'styled-components';

const StyledFilterResults = styled.section`
  .filterResults__loading,
  .filterResults__error {
    width: 100%;
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .filterResults__container {
    margin-bottom: 80px;
  }
`;

export default StyledFilterResults;
